import { BaseLandscapeService } from '../../base-landscape.service';
import { EntityGalleryTileResponseDto } from '../dto/response/entity-gallery-tile-response.dto';
import { EntityGalleryTileSaveRequestDto } from '../dto/request/entity-gallery-tile-save-request.dto';
import { EntityGalleryTileUpdateRequestDto } from '../dto/request/entity-gallery-tile-update-request.dto';

class EntityGalleryTileService extends BaseLandscapeService {
  public async fetchEntityGalleryTileById(
    id: string
  ): Promise<EntityGalleryTileResponseDto> {
    const response = await this.get<EntityGalleryTileResponseDto>(
      `/entitygallerytile/${id}`
    );
    return response.data;
  }

  public async saveEntityGalleryTile(
    saveRequest: EntityGalleryTileSaveRequestDto
  ): Promise<EntityGalleryTileResponseDto> {
    const response = await this.post<EntityGalleryTileResponseDto>(
      `/entitygallerytile`,
      saveRequest
    );
    return response.data;
  }

  public async updateEntityGalleryTile(
    updateRequest: EntityGalleryTileUpdateRequestDto
  ): Promise<EntityGalleryTileResponseDto> {
    const response = await this.put<EntityGalleryTileResponseDto>(
      `/entitygallerytile`,
      updateRequest
    );
    return response.data;
  }

  public async deleteEntityGalleryTile(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/entitygallerytile/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const entityGalleryTileService = new EntityGalleryTileService();
export default entityGalleryTileService;
